import { Pipe, PipeTransform } from "@angular/core";

@Pipe({ name: "moneyPipe" })
export class MoneyPipe implements PipeTransform {
  transform(value: string): any {
    return `$ ${value || 0}`;
  }
}
